export const dynamicInputConfig = {
  unifiedReferrals: {
    displayAttribute: 'resource_display_text',
    displayAttributeShortName: 'resource_short_name',
    displayAttributeFullName: 'resource_full_name',
    answerType: 'referral_resources',
    answerKey: 'resource_id',
    dataDestination: [{
      value: 'ancFacility',
      label: 'ANC User’s Assigned Resource'
    }, {
      value: 'pncFacility',
      label: 'PNC User’s Assigned Resource'
    }, {
      value: 'facility',
      label: 'User’s Assigned Resource'
    }]
  },
  offerings: {
    displayAttribute: 'display_text',
    displayAttributeShortName: 'shortname',
    displayAttributeFullName: 'name',
    answerType: 'offerings',
    answerKey: 'id',
    dataDestination: []
  },
  appointmentDates: {
    displayAttribute: 'appointment_dates_display_text',
    displayAttributeShortName: 'appointment_dates_shortname',
    displayAttributeFullName: 'appointment_dates',
    answerType: 'dates',
    answerKey: 'appointment_dates',
    dataDestination: []
  },
  drillDownReferrals: {
    displayAttribute: 'resource_display_text',
    displayAttributeShortName: 'resource_short_name',
    displayAttributeFullName: 'resource_full_name',
    answerType: 'referral_resources',
    answerKey: 'resource_id',
    dataDestination: [{
      value: 'ancFacility',
      label: 'ANC User’s Assigned Resource'
    }, {
      value: 'pncFacility',
      label: 'PNC User’s Assigned Resource'
    }, {
      value: 'facility',
      label: 'User’s Assigned Resource'
    }]
  }
}

export const dataDestinationConfig = {
  ancFacility: {
    model: 'anc_user',
    valueAttribute: 'answer,clinic_name',
    targetColumn: 'referral_resource_id,clinic_name',
    operation: 'UPDATE',
    matchingColumn: 'account_id'
  },
  pncFacility: {
    model: 'pnc_user',
    valueAttribute: 'answer,clinic_name',
    targetColumn: 'referral_resource_id,clinic_name',
    operation: 'UPDATE',
    matchingColumn: 'account_id'
  },
  facility: {
    model: 'user',
    valueAttribute: 'answer',
    targetColumn: 'referral_resource_id',
    operation: 'UPDATE',
    matchingColumn: 'accountid'
  }
}

export const stageTypes = {
  scoreRanking: 'scoreranking',
  scoredResponse: 'scoredresponse',
  traditional: 'traditional',
  embeddedConversation: 'embedded_conversation',
  fbOptIn: 'fbOptIn',
  journeyReminder: 'journeyReminder'
}

export const contextOptions = [
  { id: 'REF_CART_FOLLOW_UP', label: 'Referral Cart Follow Up' },
  { id: 'JOURNEY_CONTINUITY', label: 'Journey Follow Up' }
]



// WEBPACK FOOTER //
// ./src/components/conversation/constant.js